export const headerMapping = (url: string) => {
  switch (url) {
    case '/portal/consigner/vehicles':
      return 'Vehicles';
    default:
      return '';
  }
};
